import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';
import { WavePaymentInfo } from '../models/wavePaymentInfo.model';
import { environment } from '../environments/environment';
import { WavePayoutInfo } from '../models/wavePayoutInfo.model';
@Injectable({
  providedIn: 'root'
})
export class PaypalService {

  constructor(private http: HttpClient) { }

  // Reversement par Paypal
  reversementWithPaypal(KahpooReverse: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/paypal/reverse`, KahpooReverse, { headers: headers });
  }

}
